export default __webpack_public_path__ + "static/media/celo.5dff99dc.jpg";